// Module
var code = "<vt-wizard-step ws-options=\"availabilityStep.options\">\n    <select-appointment-date sad-selected-time=\"availabilityStep.selectedTime\"\n                             sad-availability-dates=\"availabilityStep.dates\"></select-appointment-date>\n</vt-wizard-step>\n";
// Exports
var _module_exports = code;;
var path = 'components/request/create/steps/availability-step.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;